import * as React from "react";
const SvgArrowRight = (props) => /* @__PURE__ */ React.createElement("svg", { width: 13, height: 12, viewBox: "0 0 13 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5.6801 3L4.9751 3.705L7.2651 6L4.9751 8.295L5.6801 9L8.6801 6L5.6801 3Z", fill: "black" }));
export default SvgArrowRight;
